import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  CardMedia,
  IconButton,
} from "@mui/material";
import PlayCircleFilledRoundedIcon from "@mui/icons-material/PlayCircleFilledRounded";
import VideoPlayer from "./VideoPlayer";
import { useParams } from "react-router-dom";
import NavigationSidebar from "../NavigationSidebar";

const CareerTransitions = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [openPlayer, setOpenPlayer] = useState(false);
  const { userId } = useParams();

  const videos = [
    {
      title: "Handling Retrenchments",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844168/1_-_Handling_Retrenchment_if2kmr.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844168/1_-_Handling_Retrenchment_if2kmr.jpg",
    },
    {
      title: "Building Career Resilience",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844169/2_-_Building_Career_Resilience_fbeuib.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844169/2_-_Building_Career_Resilience_fbeuib.jpg",
    },
    {
      title: "Starting your own business",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844173/3_-_Starting_Your_Own_Business_dufxds.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844173/3_-_Starting_Your_Own_Business_dufxds.jpg",
    },
    {
      title: "Networking for Beginners",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844167/4_-_Networking_For_Beginners_dkl8dx.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844167/4_-_Networking_For_Beginners_dkl8dx.jpg",
    },
    {
      title: "Developing your Professional Brand",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844164/5_-_Developing_Your_Professional_Brand_jusnfd.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844164/5_-_Developing_Your_Professional_Brand_jusnfd.jpg",
    },
    {
      title: "Developing a New Career Strategy",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844172/6_-_Developing_a_New_Career_Strategy_e4ee5j.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844172/6_-_Developing_a_New_Career_Strategy_e4ee5j.jpg",
    },
    {
      title: "LinkedIn Strategies",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844167/7_-_Linkedin_Strategies_sffapj.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844167/7_-_Linkedin_Strategies_sffapj.jpg",
    },
    {
      title: "Job Search Strategies",
      url: "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844164/8_-_JobSearch_Strategies_cotopv.mp4",
      thumbnail:
        "https://res.cloudinary.com/dncu0dqbk/video/upload/v1739844164/8_-_JobSearch_Strategies_cotopv.jpg",
    },
  ];

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
    setOpenPlayer(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <NavigationSidebar userId={userId} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${0}px)` },
          ml: { sm: `${0}px` },
        }}
      >
        <Card
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FFFFFF",
          }}
        >
          <CardContent sx={{ flexGrow: 1 }}>
            <Box display="flex" alignItems="center" mb={2}>
              <Typography gutterBottom variant="h5" component="div">
                Career Transitions
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" paragraph>
              Making a career transition can be both exciting and challenging.
              Whether you're changing industries, roles, or organizations,
              proper preparation and strategy are key to success.
              <br />
              <br />
              Our comprehensive course will guide you through the essential
              steps of making a successful career transition.
            </Typography>
            <Box
              sx={{
                backgroundColor: "#8DDAF0",
                margin: "0 -24px",
                padding: "0 24px",
              }}
            >
              <Grid
                container
                spacing={2}
                sx={{
                  backgroundColor: "#8DDAF0",
                  p: 2,
                  borderRadius: 2,
                }}
              >
                {videos.map((video, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index} mb={4}>
                    <Card
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        pl: 3,
                        pr: 3,
                        pt: 3,
                        borderRadius: 5,
                      }}
                    >
                      <Box sx={{ position: "relative" }}>
                        <CardMedia
                          component="img"
                          height="auto"
                          width="500"
                          image={video.thumbnail}
                          alt={video.title}
                          sx={{ borderRadius: 5 }}
                        />
                        <IconButton
                          onClick={() => handleVideoClick(video)}
                          sx={{
                            position: "absolute",
                            bottom: 8,
                            left: 8,
                            backgroundColor: "#415ED4)",
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.8)",
                            },
                            color: "white",
                          }}
                        >
                          <PlayCircleFilledRoundedIcon
                            sx={{
                              position: "absolute",
                              bottom: 8,
                              left: 8,
                              color: "#415ED4",
                              fontSize: 60,
                              backgroundColor: "#ffffff",
                              borderRadius: "50%",
                              "&:hover": {
                                transform: "scale(1.1)",
                                transition: "transform 0.2s",
                              },
                            }}
                          />
                        </IconButton>
                      </Box>
                      <CardContent
                        sx={{
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "60px",
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "left", gap: 1 }}
                        >
                          <Box
                            sx={{
                              backgroundColor: "black",
                              color: "white",
                              minWidth: "24px",
                              height: "24px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "4px",
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                          >
                            {index + 1}
                          </Box>
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {video.title}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </CardContent>
        </Card>

        <VideoPlayer
          open={openPlayer}
          onClose={() => setOpenPlayer(false)}
          videoUrl={selectedVideo?.url}
          title={selectedVideo?.title}
        />
      </Box>
    </Box>
  );
};

export default CareerTransitions;
